import { createStore$ } from '../../createStore$';
import { KioskDevice, ZoneOrderDeliveryType, Zone } from '../../XV2';
import { Table$ } from '../table/Table$';
import { Basket$ } from '../table/Basket$';

const kioskDevice = createStore$<{
    device?: KioskDevice;
}>({
    initialState: {},
});

type State = {
    zone: Zone;
};

const state = createStore$<State>({
    initialState: {
        zone: undefined as any,
    },
});

export namespace Kiosk$ {
    export const useState = state.useState;
    export const setState = state.setValue;

    export function useActiveView(): 'menu' | undefined {
        const value = state.useValue();

        if (value.zone) {
            return 'menu';
        }
    }

    export function setZone(zone: State['zone']) {
        state.setValue((state) => {
            state.zone = zone;
        });
    }

    export function useData() {
        const deviceState = kioskDevice.useValue();
        const kioskState = state.useValue();

        return {
            location: deviceState.device?.location,
            locationId: deviceState.device?.locationId || 0,
            outletId: deviceState.device?.outletId || 0,
            zoneId: kioskState.zone?.id,
            zone: kioskState.zone,
            isTakeaway: kioskState.zone?.orderDeliveryType === ZoneOrderDeliveryType.TAKEAWAY,
        };
    }

    export function useDevice() {
        return kioskDevice.useValue((state) => state.device);
    }

    export function useZones() {
        return kioskDevice.useValue((state) => state.device?.outlet?.zones || []);
    }

    export function useTakeawayZone() {
        return kioskDevice.useValue((state) => state.device?.zone);
    }

    export function setDevice(device: KioskDevice) {
        kioskDevice.setValue({ device });
    }

    export function reset() {
        Table$.reset();
        Basket$.reset();
        state.reset();
    }
}
